import {
  useBlockProps,
  InspectorControls,
  MediaUpload,
  MediaUploadCheck
} from '@wordpress/block-editor'
import {
  PanelBody,
  TextControl,
  Button,
  ToggleControl,
  TextareaControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'

export default function Edit ({ attributes, setAttributes }) {
  const {
    imageId,
    imageUrl,
    imageAlt,
    title,
    position,
    description,
    linkUrl,
    linkTarget
  } = attributes

  const blockProps = useBlockProps({
    className: `coziehomes-staff-card coziehomes-staff-card__editor`
  })

  const onSelectImage = media => {
    setAttributes({
      imageId: media.id,
      imageUrl: media.url,
      imageAlt: media.alt || ''
    })
  }

  const onRemoveImage = () => {
    setAttributes({
      imageId: 0,
      imageUrl: '',
      imageAlt: ''
    })
  }

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Staff Card Settings', 'coziehomes')}>
          <TextControl
            label={__('Name', 'coziehomes')}
            value={title}
            onChange={value => setAttributes({ title: value })}
            placeholder={__('Enter staff name', 'coziehomes')}
          />
          <TextControl
            label={__('Position', 'coziehomes')}
            value={position}
            onChange={value => setAttributes({ position: value })}
            placeholder={__('Enter staff position', 'coziehomes')}
          />
          <TextareaControl
            label={__('Description', 'coziehomes')}
            value={description}
            onChange={value => setAttributes({ description: value })}
            placeholder={__('Enter staff description', 'coziehomes')}
          />
          <TextControl
            label={__('Link URL', 'coziehomes')}
            value={linkUrl}
            onChange={value => setAttributes({ linkUrl: value })}
            placeholder={__('https://example.com', 'coziehomes')}
            type='url'
          />
          <ToggleControl
            label={__('Open in new tab', 'coziehomes')}
            checked={linkTarget}
            onChange={value => setAttributes({ linkTarget: value })}
          />
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        <MediaUploadCheck>
          <MediaUpload
            onSelect={onSelectImage}
            allowedTypes={['image']}
            value={imageId}
            render={({ open }) => (
              <>
                {imageUrl ? (
                  <div className={`coziehomes-staff-card__img-wrapper`}>
                    <img
                      src={imageUrl}
                      alt={imageAlt}
                      className='coziehomes-staff-card__img'
                      onClick={open}
                      role='presentation'
                    />
                    <Button
                      onClick={onRemoveImage}
                      isDestructive
                      size='small'
                      variant='secondary'
                      className='coziehomes-staff-card__remove-btn'
                    >
                      {__('Remove', 'coziehomes')}
                    </Button>
                  </div>
                ) : (
                  <div
                    className='coziehomes-staff-card__placeholder'
                    onClick={open}
                    role='button'
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && open()}
                  >
                    <Button
                      size='small'
                      variant='primary'
                      className='coziehomes-staff-card__upload-btn'
                    >
                      {__('Select Image', 'coziehomes')}
                    </Button>
                  </div>
                )}
              </>
            )}
          />
        </MediaUploadCheck>

        <div className='coziehomes-staff-card__details'>
          {title ? (
            <h4 className={`coziehomes-staff-card__title`}>{title}</h4>
          ) : (
            <h4 className='coziehomes-staff-card__title coziehomes-staff-card__title--placeholder'>
              {__('Add a name', 'coziehomes')}
            </h4>
          )}
          {position ? (
            <h5 className={`coziehomes-staff-card__position`}>{position}</h5>
          ) : (
            <h5 className='coziehomes-staff-card__position coziehomes-staff-card__position--placeholder'>
              {__('Add a position…', 'coziehomes')}
            </h5>
          )}
          {description ? (
            <p
              className={`coziehomes-staff-card__description`}
              dangerouslySetInnerHTML={{
                __html: description.replace(/\n/g, '<br>')
              }}
            />
          ) : (
            <p className='coziehomes-staff-card__description coziehomes-staff-card__description--placeholder'>
              {__('Add a description…', 'coziehomes')}
            </p>
          )}
        </div>
      </div>
    </>
  )
}
